import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { BusinessUserOfferManagerHandler } from '../../providers/business-user-offer-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';
import { Globals } from '../../providers/globals';
import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';

import { ConsumerOfferDetailPage } from '../consumer-offer-detail/consumer-offer-detail';

/**
 * Generated class for the BusinessUserInvoiceDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-user-invoice-detail',
  templateUrl: 'business-user-invoice-detail.html',
})
export class BusinessUserInvoiceDetailPage {
	loadingMsg: any = "Loading...";
	isLoading: boolean = false;
	offerToRedeemCount: any = 0;
	offerRedeemCount: any = 0;
	customerInfo: any;
  invoiceDetail: any;
  offerRedeem: any;
  offer: any;
  offerInfo: any;
  scannedIds: any;
  hasOffer: boolean;
  filePath: any;
  loader: any;
  offerRefreshDone: boolean = false;
  leftView: boolean = false;
  isRedeemed: boolean = false;  
  isRedeeming: boolean = false;

  constructor(
		public loadingCtrl: LoadingController,
		public offerHandler: ConsumerOfferManagerHandler,
		public navCtrl: NavController, 
		public navParams: NavParams,
    public viewCtrl: ViewController,
    public consumerHandlerProvider: ConsumerHandlerProvider,
    public businessUserOfferManagerHandler: BusinessUserOfferManagerHandler,
    public alertCtrl: AlertController,
    public globals: Globals,
    public actionSheetCtrl: ActionSheetController) {

  	this.invoiceDetail = navParams.data;

    this.offerHandler.invoiceId = this.invoiceDetail.invoice.Id;
    this.consumerHandlerProvider.currentIdentityUserId = this.invoiceDetail.user.IdentityUserId;
  	
	}

  ionViewWillEnter(){
		this.loadInvoiceDetail(false);
	}		

	loadInvoiceDetail(isStamping){

    if(isStamping) {
      var loader = this.loadingCtrl.create({
        content: "Stamping...",
        showBackdrop: true
      });

      loader.present(); 
    } else
		  this.isLoading = true;
    

		if(this.offerHandler.selectedOffer.InvoiceId!=null){
			this.offerHandler.invoiceId = this.offerHandler.selectedOffer.InvoiceId;
		}

		this.offerHandler.getOfferMulti(
			{
				id: this.offerHandler.invoiceId, 
				cb: (data: any)=>{
					this.offerToRedeemCount = this.offerHandler.offerToRedeemCount();
					this.offerRedeemCount = this.offerHandler.offerRedeemCount();
					
          if(isStamping)
            loader.dismiss();
          else
					this.isLoading = false;
				}
			}
		);
	}	

  confirmRedeem(){
    let alert = this.alertCtrl.create({
      title: 'Stamp invoice?',
      message: 'Are you sure you want to stamp this invoice?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            
          }
        },
        {
          text: 'Confirm',
          handler: () => {  
            this.redeem();
          }
        }
      ]
    });

    alert.present();
  }    

	redeem(){
    if(this.isRedeeming) return;

    this.isRedeeming = true;

    this.businessUserOfferManagerHandler.redeemForUser({
      invoiceId: this.invoiceDetail.invoice.Id,
      userId: this.invoiceDetail.user.Id,
      cb:(result)=>{
        if(result.Success){
          let alert = this.alertCtrl.create({
            title: 'Success',
            subTitle: 'Offer has been redeemed!',
            buttons: ['Ok']
          });

          alert.present();

          this.loadInvoiceDetail(true);

          this.isRedeemed = true

          this.isRedeeming = false;
        } else { 
          
          let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: result.Message,
              buttons: ['Ok']
            });
            
            alert.present();

            this.isRedeeming = false; 
        }
      }
    })

  }

  cancelRedeem(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-user-invoice-detail/business-user-invoice-detail.ts